// import React from 'react'
import React, { useEffect, useRef, useState } from 'react'
import Topbar from './Topbar'
import Navbar from './Navbar'
import { useLocation } from 'react-router-dom';

function HeaderNew() {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [showHeader, setShowHeader] = useState(true);

  const togglerRef = useRef(null);
  const location = useLocation();
  useEffect(()=>{

    const allowedPages = ["/", "/products"];

if (!allowedPages.includes(location.pathname)) {
  setShowHeader(true);
  return;
}

    // if(location.pathname !== "/products"){
    //   setShowHeader(true);
    //   return;
    // }
    let lastScroll = window.scrollY;

    // const handleScroll = () => {

    //   const currentScroll = window.scrollY;

    //   if (currentScroll > lastScroll) {

    //     // scroll down → show
    //     setShowHeader(true);

    //   } else {

    //     // scroll up → hide
    //     setShowHeader(false);

    //   }

    //   lastScroll = currentScroll;

    // };

//     const handleScroll = () => {

//   const currentScroll = window.scrollY;

//   // ✅ Always show at top
//   if (currentScroll <= 0) {
//     setShowHeader(true);
//   }

//   else if (currentScroll > lastScroll) {

//     // scroll down → show
//     setShowHeader(true);

//   } else {

//     // scroll up → hide
//     setShowHeader(false);

//   }

//   lastScroll = currentScroll;

// };

const handleScroll = () => {
  const currentScroll = window.scrollY;

  if (currentScroll <= 10) {
    setShowHeader(true);
  } else if (currentScroll > lastScroll + 5) {
    // scroll down fast
    setShowHeader(false);
  } else if (currentScroll < lastScroll - 5) {
    // scroll up
    setShowHeader(true);
  }

  lastScroll = currentScroll;
};
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);

  }, [location.pathname])
  return (
   
    <>
     {/* <div className="header-fixed-wrapper "> */}
<div className={`header-fixed-wrapper ${showHeader ? "show-header" : "hide-header"}`}>
        <Topbar
          isNavOpen={isNavOpen}
          setIsNavOpen={setIsNavOpen}
          togglerRef={togglerRef}
        />

        <Navbar
          isNavOpen={isNavOpen}
          setIsNavOpen={setIsNavOpen}
          togglerRef={togglerRef}
        />
      </div>

      {/* Spacer */}
      <div className="header-spacer"></div>
    </>
  )
}

export default HeaderNew;


